<template>
  <div class="order_list">
    <!-- 头部搜索 -->
    <title-bar-search :showBack="true" class="title_search" @back="back">
      <div class="input_s clearfix" @click="goSearch">
        <img
          src="@/assets/common/icon_search_search@2x.png"
          alt="select"
          class="search_img left"
        />
        <div class="search_name left">订单号/商品名称/收货人</div>
      </div>
    </title-bar-search>
    <div class="line_height"></div>
    <!-- switchBar -->
    <switch-bar-list :switchIndex="switchIndex" @clickSwitch="clickSwitch" />
    <!-- 订单 -->
    <van-pull-refresh
      v-if="
        findClientRetailOrderByParam.rows &&
          findClientRetailOrderByParam.rows.length !== 0
      "
      v-model="loading"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="!findClientRetailOrderByParam.hasNextPage"
        finished-text="我已经到底啦～"
        @load="onLoad"
      >
        <div class="order_list_items">
          <div
            v-for="(item, index) in findClientRetailOrderByParam.rows"
            :key="index"
            class="items"
          >
            <!-- 订单头部信息 -->
            <order-header :storeDet="item" @clickBtn="clickBtn" />
            <div v-for="(i, index1) in item.retailSubOrderList" :key="index1">
              <div
                v-if="
                  item.retailSubOrderList &&
                    item.retailSubOrderList.length > 1 &&
                    item.retailSubOrderList !== null
                "
                :class="{ bao_mr: index1 !== 0 }"
                class="font12 font_weight500 colo087 text_left bao_name"
              >
                包裹{{ index1 + 1 }}
              </div>
              <!-- 商品信息 -->
              <div>
                <div v-for="(i1, index2) in i.orderDetailList" :key="index2">
                  <order-product-list
                    v-if="!i1.isGift"
                    :listIndex="index2"
                    :pageShow="false"
                    :item="i1"
                    :i="item"
                    @goOrderDetail="goOrderDetail"
                  />
                  <!-- 赠品 -->
                  <div v-if="i1.isGift" class="free_product_list">
                    <free-product
                      :showBor="false"
                      :freeProduct="i1"
                      :orderSn="item.orderSn"
                      @goOrderDetail="goOrderDetail"
                    />
                  </div>
                </div>
                <!-- 多包裹底部按钮 -->
                <bottom-btn
                  v-if="showPackageBtn(item)"
                  :i="i"
                  :item="item"
                  :packageIndex="index1"
                  @clickBtn="clickBtn"
                />
              </div>
            </div>

            <!-- 订单（单包裹）底部按钮 -->
            <bottom-btn
              v-if="showWholeOrderBtn(item)"
              :i="item.retailSubOrderList[item.retailSubOrderList.length - 1]"
              :item="item"
              :packageIndex="0"
              @clickBtn="clickBtn"
            />
            <div class="order_total_det font12 font_weight500 line_height_17">
              <div v-if="item.deliveryMode === 0" class="pickup_info">
                自提：{{ item.pickupAddress ? item.pickupAddress.name : "" }}
              </div>
              <div class="colo0 total_info">
                共{{ item.totalNum }}件商品 总计：{{
                  item.total | currency(false)
                }}
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <cancel-action-sheet
      v-if="showCancel"
      @closeSheet="closeSheet"
      @confirmReasion="confirmReasion"
    />
    <!-- 无结果 -->
    <div
      v-if="
        findClientRetailOrderByParam.rows &&
          findClientRetailOrderByParam.rows.length === 0
      "
      class="none_list"
    >
      <img src="@/assets/order/search_none_product@2x.png" alt="" />
      <div class="font14 font_weight400 colo038 line_height_20">
        未找到相关订单
      </div>
    </div>
  </div>
</template>
<script>
import TitleBarSearch from "@/components/TitleBarSearch";
import SwitchBarList from "./components/SwitchBarList";
import OrderHeader from "./components/OrderHeader";
import OrderProductList from "./components/OrderProductList";
import BottomBtn from "./components/BottomBtn";
import FreeProduct from "../detail/components/FreeProduct";
import CancelActionSheet from "../detail/components/CancelActionSheet";
export default {
  name: "OrderList",
  components: {
    TitleBarSearch,
    SwitchBarList,
    OrderHeader,
    OrderProductList,
    BottomBtn,
    FreeProduct,
    CancelActionSheet
  },
  data() {
    return {
      switchIndex: 0,
      loading: false,
      showCancel: false,
      orderSn: ""
    };
  },
  computed: {
    findClientRetailOrderByParam() {
      return this.$store.getters.findClientRetailOrderByParam;
    }
  },
  created() {
    this.switchIndex =
      parseInt(localStorage.getItem("mall-order-list-index")) || 0;
    this.getData(this.switchIndex);
  },
  methods: {
    // findClientRetailOrderByParam
    getData(status = 0, pageNo = 1, pageSize = 20) {
      const params = {
        pageNo,
        pageSize,
        status
      };
      // console.log(params, "params");
      this.$store
        .dispatch("order/findClientRetailOrderByParam", { params })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {});
    },
    onRefresh() {
      this.getData(this.switchIndex);
    },
    onLoad() {
      // console.log("上拉进行中");
      this.loading = false;
      if (
        this.findClientRetailOrderByParam.hasNextPage &&
        this.findClientRetailOrderByParam.pageNo <
          this.findClientRetailOrderByParam.pageCount
      ) {
        this.loading = true;
        const pageIndex = this.findClientRetailOrderByParam.pageNo + 1;
        this.getData(this.switchIndex, pageIndex);
        // console.log("上拉完毕");
      }
    },
    back() {
      this.$router.push("/mine");
    },
    // 订单搜索跳转
    goSearch() {
      this.$router.push("/order/searchorder");
    },
    // 点击切换bar
    clickSwitch(index) {
      this.switchIndex = index;
      localStorage.setItem("mall-order-list-index", index);
      scrollTo(0, 0);
      this.getData(index);
    },
    closeSheet() {
      this.showCancel = false;
    },
    confirmReasion(refundReason) {
      this.cancelData(refundReason);
    },
    // 跳转详情
    goOrderDetail(orderSn) {
      this.$router.push({
        path: "/order/detail",
        query: {
          orderSn
        }
      });
    },
    isCloseStatus(status) {
      return status < 0 && status !== -5 && status !== -9;
    },
    showPackageBtn(item) {
      if (!item.retailSubOrderList || item.retailSubOrderList === null)
        return false;
      const length = item.retailSubOrderList.length;
      if (length > 1) {
        const status = item.status;
        if (status === 10) return false;
        if (this.isCloseStatus(status)) return false;
        return true;
      }
      return false;
    },
    showWholeOrderBtn(item) {
      if (!item.retailSubOrderList || item.retailSubOrderList === null)
        return false;
      const length = item.retailSubOrderList.length;
      if (length === 1) return true;
      if (length > 1) {
        const status = item.status;
        if (status === 10) return true;
        if (this.isCloseStatus(status)) return true;
      }
      return false;
    },
    // 取消接口
    cancelData(refundReason) {
      this.$store
        .dispatch("order/cancelOrder", {
          params: {
            orderSn: this.orderSn,
            refundReason
          }
        })
        .then(() => {
          this.getData(this.switchIndex);
          this.showCancel = false;
          this.$toast("订单取消成功");
        })
        .catch(() => {});
    },
    // 删除接口
    deleteData(orderSn) {
      this.$store
        .dispatch("order/deleteOrder", {
          params: {
            orderSn
          }
        })
        .then(() => {
          this.getData(this.switchIndex);
          this.showCancel = false;
          this.$toast("订单删除成功");
        })
        .catch(() => {});
    },
    // 再次购买接口
    againBuy(orderSn) {
      this.$store
        .dispatch("order/againBuy", {
          params: {
            orderSn
          }
        })
        .then(() => {
          this.$router.push("/cart");
        })
        .catch(() => {});
    },
    // 确认收货
    confirmOrder(subOrderSn) {
      this.$store
        .dispatch("order/confirmOrder", {
          params: {
            subOrderSn
          }
        })
        .then(() => {
          this.getData(this.switchIndex);
        })
        .catch(() => {});
    },
    getSpuId(item) {
      const { retailSubOrderList } = item;
      let spuId = "";
      retailSubOrderList.forEach(item => {
        item.orderDetailList.forEach(i => {
          if (!i.isGift) {
            spuId = i.spuId;
            return;
          }
        });
      });
      return spuId;
    },
    // 点击按钮
    clickBtn(name, orderSn, subOrderSn, packageIndex, orderType, spuId, item) {
      switch (name) {
        case "分享订单":
          if (item && item.shareUrl) {
            this.copyToClipboard(item.shareUrl);
          } else {
            this.$toast("暂无分享链接");
          }
          break;
        case "取消订单":
          this.showCancel = true;
          this.orderSn = orderSn;
          break;
        case "去付款":
          // /order/orderpay?orderSn=FY20112062347625
          this.$router.push({
            path: "/order/orderpay",
            query: {
              orderSn
            }
          });
          break;
        case "查看物流":
          this.$router.push({
            path: "/order/detail/logistics",
            query: {
              orderSn,
              subOrderSn,
              packageIndex
            }
          });
          break;
        case "提醒发货":
          this.$toast("已提醒发货");
          break;
        case "申请退款":
          this.$router.push({
            path: "/order/refund/orderdetailrefundreasion",
            query: {
              orderSn,
              name: this.getUserOrder.address.name,
              phone: this.getUserOrder.address.phone
            }
          });
          break;
        case "确认收货":
          this.$dialog
            .confirm({
              message: "您确定要确认收货吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              // 确认收货
              this.confirmOrder(subOrderSn);
            })
            .catch(() => {});
          break;
        case "再次购买":
          if (orderType === 0) {
            this.againBuy(orderSn);
          } else {
            // 跳转详情
            this.$router.push({
              path: "/product/detail",
              query: {
                id: spuId || this.getSpuId(item)
              }
            });
          }
          break;
        case "申请售后":
          this.$router.push({
            path: "/order/refund/applypackage",
            query: {
              orderType: this.getUserOrder.orderType,
              orderSn
            }
          });
          break;
        case "删除订单":
          this.$dialog
            .confirm({
              message: "您确定要删除该订单吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              this.deleteData(orderSn);
            })
            .catch(() => {});
          break;
        case "配送计划":
          this.$router.push({
            path: "/order/milkplan",
            query: {
              orderSn,
              subOrderSn
            }
          });
          break;
        case "前往使用":
          this.$router.push({
            path: "/mine/cardpackagelist"
          });
          break;
        case "去评价":
          this.$router.push({
            path: "/order/review",
            query: {
              orderSn,
              subOrderSn
            }
          });
          break;
      }
    },
    // 复制剪切板逻辑
    copyToClipboard(text) {
      const input = document.createElement("input");
      input.setAttribute("value", text);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$toast("订单分享链接已复制，可发送给客户付款");
      } else {
        this.$toast("复制失败，请手动长按复制");
      }
      document.body.removeChild(input);
    },
    // 取消订单
    cancelOrder() {
      this.showCancel = true;
    }
  }
};
</script>
<style lang="less" scoped>
.order_list {
  // background: #fff;
  .title_search {
    background: #fff;
  }
  .input_s {
    text-align: left;
    background: #f6f7f8;
    border-radius: 17px;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    height: 34px;
    .search_name {
      margin-left: 12px;
      margin-top: auto;
      margin-bottom: auto;
      font-weight: 400;
      color: #222;
      padding: 8px 0;
      opacity: 0.38;
    }
    .search_img {
      // margin-top: 2px;
      margin-left: 8px;
      width: 24px;
      margin-top: auto;
      margin-bottom: auto;
    }
  }
  .line_height {
    height: 48px;
  }
  .order_list_items {
    margin-top: 57px;
    .items {
      background: #fff;
      margin-top: 12px;
      .bao_name {
        padding: 4px 12px;
      }
      .bao_mr {
        // border-top: 4px solid #f6f7f8;
      }
    }
  }
  .free_product_list {
    background: #fff;
    margin: 0 12px;
  }
  .none_list {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 60px;
    }
  }
}
.order_total_det {
  padding: 16px 22px 16px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .pickup_info {
    color: rgba(0, 0, 0, 0.85);
  }
  .total_info {
    margin-left: auto;
  }
}
</style>
